/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Header from 'parts/Header';
import PrivacyPolicy from 'parts/PrivacyPolicy';
import Footer from 'parts/Footer';

export default class PrivacyPolicyPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <PrivacyPolicy />
        <Footer />
      </>
    );
  }
}
